// The dashboard someone last opened in this browser, so signing in again (or ending a view as
// someone) lands back on it. Kept per person: a shared browser doesn't hand one person's to another.

const key = (userId: string) => `lastDashboard:${userId}`;

export function lastDashboard(userId: string): string | null {
  try {
    return localStorage.getItem(key(userId));
  } catch {
    return null;
  }
}

export function rememberDashboard(userId: string, id: string) {
  try {
    localStorage.setItem(key(userId), id);
  } catch {
    /* private mode */
  }
}
